'use client';

import HeroSection from './HeroSection';
import SearchSection from './SearchSection';
import BookingReservationsSection from './BookingReservationsSection';
import AmenitiesServicesSection from './AmenitiesServicesSection';
import PoliciesTermsSection from './PoliciesTermsSection';
import PaymentsBillingSection from './PaymentsBillingSection';
import LocationAccessSection from './LocationAccessSection';
import Footer from '@/app/homepage/components/Footer';

export default function FAQInteractive() {
  return (
    <>
      <HeroSection />
      <SearchSection />
      <BookingReservationsSection />
      <AmenitiesServicesSection />
      <PoliciesTermsSection />
      <PaymentsBillingSection />
      <LocationAccessSection />
      <Footer />
    </>
  );
}